var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Brit flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings/Account",
    transform: "translate(-318.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(8.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instelling-taal",
    transform: "translate(20.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brit-flag",
    transform: "translate(290.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,7.59898939 L12.4010106,5.59029813 L16.7583628,2.62961091 C15.5440121,1.51551289 14.0535624,0.69732188 12.4010106,0.2902476 L12.4010106,7.59898939",
    id: "Fill-254",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9202628,14.5245073 C19.2598282,13.8562911 19.5266296,13.1452249 19.7097524,12.4014149 L15.7954522,12.4014149 L18.9202628,14.5245073",
    id: "Fill-255",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,7.59898939 L7.59898939,0.2902476 C5.94684184,0.69732188 4.45598787,1.51551289 3.24163719,2.62961091 L7.59898939,5.59029813 L7.59898939,7.59898939",
    id: "Fill-256",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2902476,12.4014149 C0.473774634,13.1452249 0.740171804,13.8562911 1.07973724,14.5245073 L4.20454775,12.4014149 L0.2902476,12.4014149",
    id: "Fill-257",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,12.4014149 L7.59898939,14.4101061 L3.24163719,17.3707933 C4.45598787,18.4848914 5.94684184,19.3026781 7.59898939,19.7097524 L7.59898939,12.4014149",
    id: "Fill-258",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07973724,5.47589692 C0.740171804,6.14370894 0.473774634,6.85477514 0.2902476,7.59898939 L4.20454775,7.59898939 L1.07973724,5.47589692",
    id: "Fill-259",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,12.4014149 L12.4010106,19.7097524 C14.0535624,19.3026781 15.5440121,18.4848914 16.7583628,17.3707933 L12.4010106,14.4101061 L12.4010106,12.4014149",
    id: "Fill-260",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7097524,7.59898939 C19.5266296,6.85477514 19.2598282,6.14370894 18.9202628,5.47589692 L15.7954522,7.59898939 L19.7097524,7.59898939",
    id: "Fill-261",
    fill: "#10459B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,12.4014149 L19.7097524,12.4014149 C19.7703891,12.1560384 19.8217281,11.9070237 19.8637696,11.6547751 L12.4010106,11.6547751 L12.4010106,12.4014149",
    id: "Fill-262",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63274381,12.4014149 L7.59898939,12.4014149 L7.59898939,11.6547751 L0.136230419,11.6547751 C0.178271854,11.9070237 0.229610915,12.1560384 0.2902476,12.4014149 L5.63274381,12.4014149",
    id: "Fill-263",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7954522,7.59898939 L12.4010106,7.59898939 L12.4010106,8.34522486 L19.8637696,8.34522486 C19.8217281,8.0933805 19.7703891,7.84436584 19.7097524,7.59898939 L15.7954522,7.59898939",
    id: "Fill-264",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,7.59898939 L0.2902476,7.59898939 C0.229610915,7.84436584 0.178271854,8.0933805 0.136230419,8.34522486 L7.59898939,8.34522486 L7.59898939,7.59898939",
    id: "Fill-265",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6547751,8.34522486 L12.4010106,8.34522486 L12.4010106,0.2902476 C12.1560384,0.229610915 11.9070237,0.178271854 11.6547751,0.136230419 L11.6547751,8.34522486",
    id: "Fill-266",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34522486,11.6547751 L7.59898939,11.6547751 L7.59898939,19.7097524 C7.84436584,19.7703891 8.09297625,19.8217281 8.34522486,19.8637696 L8.34522486,11.6547751",
    id: "Fill-267",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,8.34522486 L8.34522486,8.34522486 L8.34522486,0.136230419 C8.09297625,0.178271854 7.84436584,0.229610915 7.59898939,0.2902476 L7.59898939,8.34522486",
    id: "Fill-268",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,11.6547751 L11.6547751,11.6547751 L11.6547751,19.8637696 C11.9070237,19.8217281 12.1560384,19.7703891 12.4010106,19.7097524 L12.4010106,11.6547751",
    id: "Fill-269",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6547751,8.34522486 L11.6547751,0.136230419 C11.1167256,0.0468923699 10.5637191,-1.14893216e-15 10.0002021,-1.14893216e-15 C9.43628095,-1.14893216e-15 8.88367863,0.0468923699 8.34522486,0.136230419 L8.34522486,8.34522486 L0.136230419,8.34522486 C0.0468923699,8.88367863 0,9.43628095 0,10.0002021 C0,10.5637191 0.0468923699,11.1167256 0.136230419,11.6547751 L8.34522486,11.6547751 L8.34522486,19.8637696 C8.88367863,19.9535119 9.43628095,20 10.0002021,20 C10.5637191,20 11.1167256,19.9535119 11.6547751,19.8637696 L11.6547751,11.6547751 L19.8637696,11.6547751 C19.9535119,11.1167256 20,10.5637191 20,10.0002021 C20,9.43628095 19.9535119,8.88367863 19.8637696,8.34522486 L11.6547751,8.34522486",
    id: "Fill-270",
    fill: "#BA1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,7.59898939 L7.59898939,5.59029813 L3.24163719,2.62961091 C2.77513896,3.05770591 2.34946943,3.52945932 1.97069227,4.03840323 L7.2598282,7.59898939 L7.59898939,7.59898939",
    id: "Fill-271",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63274381,7.59898939 L1.4621526,4.79110662 C1.32592218,5.01384538 1.19858514,5.24224356 1.07973724,5.47589692 L4.20454775,7.59898939 L5.63274381,7.59898939",
    id: "Fill-272",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2598282,7.59898939 L1.97069227,4.03840323 C1.79039919,4.28094997 1.62061647,4.5323901 1.4621526,4.79110662 L5.63274381,7.59898939 L7.2598282,7.59898939",
    id: "Fill-273",
    fill: "#BA1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,7.59898939 L12.740576,7.59898939 L18.0293077,4.03840323 C17.6509348,3.52945932 17.224861,3.05770591 16.7583628,2.62961091 L12.4010106,5.59029813 L12.4010106,7.59898939",
    id: "Fill-274",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7954522,7.59898939 L18.9202628,5.47589692 C18.8018191,5.24224356 18.6740778,5.01384538 18.5378474,4.79110662 L14.3672562,7.59898939 L15.7954522,7.59898939",
    id: "Fill-275",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3672562,7.59898939 L18.5378474,4.79110662 C18.3797878,4.5323901 18.2100051,4.28094997 18.0293077,4.03840323 L12.740576,7.59898939 L14.3672562,7.59898939",
    id: "Fill-276",
    fill: "#BA1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20454775,12.4014149 L1.07973724,14.5245073 C1.19858514,14.7581607 1.32592218,14.9865589 1.4621526,15.2088934 L5.63274381,12.4014149 L4.20454775,12.4014149",
    id: "Fill-277",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59898939,12.4014149 L7.2598282,12.4014149 L1.97069227,15.9615968 C2.34946943,16.4709449 2.77513896,16.9426983 3.24163719,17.3707933 L7.59898939,14.4101061 L7.59898939,12.4014149",
    id: "Fill-278",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63274381,12.4014149 L1.4621526,15.2088934 C1.62061647,15.4680141 1.79039919,15.71905 1.97069227,15.9615968 L7.2598282,12.4014149 L5.63274381,12.4014149",
    id: "Fill-279",
    fill: "#BA1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3672562,12.4014149 L18.5378474,15.2088934 C18.6740778,14.9865589 18.8018191,14.7581607 18.9202628,14.5245073 L15.7954522,12.4014149 L14.3672562,12.4014149",
    id: "Fill-280",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4010106,12.4014149 L12.4010106,14.4101061 L16.7583628,17.3707933 C17.224861,16.9426983 17.6509348,16.4709449 18.0293077,15.9615968 L12.740576,12.4014149 L12.4010106,12.4014149",
    id: "Fill-281",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.740576,12.4014149 L18.0293077,15.9615968 C18.2100051,15.71905 18.3797878,15.4680141 18.5378474,15.2088934 L14.3672562,12.4014149 L12.740576,12.4014149",
    id: "Fill-282",
    fill: "#BA1A1A"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag-en.70d04fd6a91083fef85a5cab43274a5d.svg";
export { ForwardRef as ReactComponent };